import { useQuery } from "@tanstack/react-query";
import { dashboardSettingsApi } from "../api";
import { qk } from "../../lib/queryKeys";
import { useSessionQuery } from "../../features/auth/hooks";
import { useClientScope } from "../contexts";
import { clientManagementApi } from "../../features/admin/settings/api/clientManagement";

export const useClientDashboardSettings = () => {
  const { data: session } = useSessionQuery();
  const { effectiveClientId, isCentralAdmin } = useClientScope();
  const clientId = isCentralAdmin
    ? effectiveClientId
    : session?.user?.client_id || null;

  return useQuery({
    queryKey: qk.dashboardSettings(clientId),
    queryFn: () =>
      isCentralAdmin && clientId
        ? clientManagementApi.listClientDashboardSettings(clientId)
        : dashboardSettingsApi.listCurrentClientDashboardSettings(),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
